module.exports = __webpack_public_path__ + "img/jjtd.8035ec1a.png";